import axios from "axios";

const apiClient = axios.create({
    baseURL: 'https://us-east-1.aws.data.mongodb-api.com/app/application-0-nnmufpi/endpoint/',
    headers: {
        'Content-Type': 'application/json',
    }
});

export default {
    get(endpoint) {
        return apiClient.get(endpoint);
    },
    post(endpoint, data) {
        return apiClient.post(endpoint, data);
    },
    put(endpoint, data) {
        return apiClient.put(endpoint, data);
    },
    sendCreateScheduleEmail(email, scheduleId) {
        const data = {};
        data.to = email;
        data.scheduleId = scheduleId
        return apiClient.post('sendCreateScheduleEmail', data)
    }
}


// WEBPACK FOOTER //
// ./src/services/atlasAPI.js